import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Topbar } from "./topbar";
import { Rail } from "./rail";

// Shared shell for every route: left nav rail (Rail, w-64) + top bar
// (Topbar, h-14) wrapping the routed page, matching the reference mockups'
// desktop structure exactly (pl-64/pt-14 offsets, not a flex layout — both
// chrome pieces are `fixed`) above the `md` breakpoint. Below it the rail
// becomes an off-canvas drawer (closed by default) toggled by Topbar's
// hamburger button, since a permanently-visible 256px rail left no usable
// width on a phone. Open state lives here, not in Rail/Topbar, since both
// need it — Topbar owns the toggle button, Rail owns the panel it opens.
export function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [desktopRailCollapsed, setDesktopRailCollapsed] = useState(false);

  return (
    <>
      <Rail
        open={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
        collapsed={desktopRailCollapsed}
        onCollapsedChange={() => setDesktopRailCollapsed((value) => !value)}
      />
      <Topbar
        onMenuClick={() => setMobileNavOpen((value) => !value)}
        railCollapsed={desktopRailCollapsed}
      />
      <div className={desktopRailCollapsed ? "md:pl-16 flex flex-col min-h-screen" : "md:pl-64 flex flex-col min-h-screen"}>
        <main className="w-full pt-14 bg-background min-h-[calc(100vh-3.5rem)]">
          <Outlet />
        </main>
      </div>
    </>
  );
}
